<div class="feature-card">
  <div class="right-container">
    <mat-tab-group [(selectedIndex)]="tabIndex" [animationDuration]="0" [disableRipple]="true" (selectedTabChange)="tabChanged($event.index)">
      <mat-tab>
        <ng-template mat-tab-label>
          <div>
            <span>{{ 'module.userProfile.generalConfiguration.basicTabLabel' | translate }}</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="tab-content">
            <app-basic-features-activation-tab></app-basic-features-activation-tab>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>
            <span>{{ 'module.userProfile.generalConfiguration.premiumTabLabel' | translate }}</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="tab-content">
            <app-premium-features-activation-tab></app-premium-features-activation-tab>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>
            <span>{{ 'module.userProfile.generalConfiguration.externeAppsTabLabel' | translate }}</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="tab-content">
            <app-externe-apps-activation-tab></app-externe-apps-activation-tab>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
